// $(document).ready(function(){
//   $('.Homepage_collection_container').slick({
//     infinite: true,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     arrows: true,
//     prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/2681/2616/files/Icon_ionic-ios-arrow-forward.png?v=1682325349'/></button>",
//     nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/2681/2616/files/Icon_ionic-ios-arrow-forward.png?v=1682325349'/></button>",
//     responsive: [
//       {
//         breakpoint: 800,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: false
//         }
//       }
//     ]
//   });
  
//   $('.Homepage_reviews_inner').slick({
//     infinite: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     centerMode: true,
//     dots: true,
//     responsive: [
//       {
//         breakpoint: 800,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           centerMode: false
//         }
//       }
//     ]
//   });
  
//   // Collection filtering
//   $('.Homepage_collection_filter_trigger').click(function(){
//     var data = $(this).attr('data');
//     $('.Homepage_collection_container').hide();
//     $(this).parent('.Homepage_collection_filter').find('.Homepage_collection_filter_trigger').removeClass('active');
//     $(this).addClass('active');
//     $('.Homepage_collection_container').each(function(){
//       console.log($(this).attr('data'), data);
//       if ($(this).attr('data') == data){
//         $(this).show();
//       }
//     });
//     $('.Homepage_collection_container').slick('refresh');
//   });
// });


$(document).ready(function(){
  // $('.Homepage_collection_container').slick({
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  //   arrows: true,
  //   prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/2681/2616/files/Icon_ionic-ios-arrow-forward.png?v=1682325349'/></button>",
  //   nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/2681/2616/files/Icon_ionic-ios-arrow-forward.png?v=1682325349'/></button>",
  //   responsive: [
  //     {
  //       breakpoint: 800,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false
  //       }
  //     }
  //   ]
  // });
  
  $('.Homepage_reviews_inner').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    dots: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
  
  // Collection filtering
  $('.Homepage_collection_filter_trigger').click(function(){
    var data = $(this).attr('data');
    $('.Homepage_collection_container').hide();
    $(this).parent('.Homepage_collection_filter').find('.Homepage_collection_filter_trigger').removeClass('active');
    $(this).addClass('active');
    $('.Homepage_collection_container').each(function(){
      console.log($(this).attr('data'), data);
      if ($(this).attr('data') == data){
        $(this).css('display', 'grid');
      }
    });
  //   $('.Homepage_collection_container').slick('refresh');
  });
});
